import { useState } from "react";
import { useTranslation } from 'react-i18next';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Menu, MenuItem, Typography } from "@mui/material";
import CustomIconButton from "../../../core-components/theme/components/Button/Iconbutton";
import { Neutrals } from "../../../core-components/theme/color-palette/colors";
import DetailIcon from "../../../core-components/assets/icons/DetailIcon";
import DeleteFilledIcon from "../../../core-components/assets/icons/DeleteIconFilled";
import ConfirmationDialog from "../../../core-components/theme/components/DialogBox/ConfirmationDialog";
import { downloadFileFromUrl } from "../../../utilities/helpers";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

const FMListingActionDropdown: React.FC<{ row: any; handleDelete: any; handleView: any }> = ({
  row,
  handleDelete,
  handleView,
}) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  //@ts-ignore
  const [open, setOpen] = useState(false);
  const [confirmationOpen, setConfirmationOpen] = useState(false);

  function handleConfirmationOpen() {
    setConfirmationOpen(true);
  }
  function handleConfirmationClose() {
    setConfirmationOpen(false);
    handleMenuClose();
  }
  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };


  return (
    <>
      <CustomIconButton onClick={handleMenuOpen} icon={MoreVertIcon}/>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        slotProps={{
          paper: {
            style: {
              boxShadow: '0px 2px 8px 0px #1A335626',
            },
          },
        }}
        MenuListProps={{
          sx: {
            border: `1px solid ${Neutrals[300]}`,
            py: 0,
            backgroundColor: '#ffffff',
            borderRadius: '4px',
          },
        }}
      >
        <MenuItem
          onClick={() => {handleMenuClose (); handleView(row)}}
          sx={{
            paddingLeft: '8px',
            height: '36px',
            borderBottom: `1px solid ${Neutrals[300]}`,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <DetailIcon />
          <Typography ml={2} pr={2} color={Neutrals[500]}>
            {t('fileManager.view', 'View')}
          </Typography>
        </MenuItem>
        {/* for edit page */}
        <MenuItem
          sx={{
            height: '36px',
            borderBottom: `1px solid ${Neutrals[300]}`,
            display: 'flex',
            paddingLeft: '8px',
            alignItems: 'center',
          }}
          onClick={() => {handleMenuClose (); downloadFileFromUrl(`https://digitalpannifilemanagement.s3.ap-south-1.amazonaws.com/${row?.s3Key}`, row?.fileName)}}
        >
          <CloudDownloadIcon sx={{ color: Neutrals[300], fontSize: '14px'}} />
          <Typography ml={2} pr={2} color={Neutrals[500]}>
            {t('fileManager.download', 'Download')}
          </Typography>
        </MenuItem>
        <MenuItem
          sx={{ height: '36px', paddingLeft: '8px', display: 'flex', alignItems: 'center' }}
          onClick={handleConfirmationOpen}
        >
          <DeleteFilledIcon />
          <Typography ml={2} pr={2} color={Neutrals[500]}>
            {t('common.delete', 'Delete')}
          </Typography>
        </MenuItem>


        <ConfirmationDialog
          open={confirmationOpen}
          handleClose={handleConfirmationClose}
          title={t('fileManager.deleteDocument', 'Delete Document')}
          description={
            <Typography variant="h4">
              {t('fileManager.deleteConfirmPrefix', 'Are you sure you want to delete')} <strong>{row?.fileName}</strong>?
            </Typography>
          }
          actions={[
            {
              text: t('common.cancel', 'Cancel'),
              color: 'white',
              textColor: '#8B8B8B',
              handler: () => console.log('cancel clicked'), // Todo: handle cancel
            },
            {
              text: t('common.delete', 'Delete'),
              color: 'SemanticError.dark',
              textColor: 'white',
              handler: () => handleDelete(row),
            },
          ]}
        ></ConfirmationDialog>
      </Menu>
    </>
  );
}

export default FMListingActionDropdown;